import { Wifi, WifiOff } from 'lucide-react'
import { useWebSocket } from '../contexts/WebSocketContext'
import { cn } from '../lib/utils'

export function ConnectionStatus() {
  const { isConnected } = useWebSocket()

  return (
    <div
      className={cn(
        'flex items-center space-x-2 px-3 py-1.5 rounded-full text-xs font-medium transition-colors',
        isConnected
          ? 'bg-green-100 text-green-700'
          : 'bg-red-100 text-red-700'
      )}
      title={isConnected ? 'Live connection active' : 'Disconnected from live updates'}
    >
      {isConnected ? (
        <>
          <Wifi className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Live</span>
        </>
      ) : (
        <>
          <WifiOff className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Offline</span>
        </>
      )}
    </div>
  )
}
